module.exports = __webpack_public_path__ + "static/media/acceptable-photo-example@2x.3b80c336.jpg";